// extracted by mini-css-extract-plugin
export default {"add_btn":"Button_add_btn__NHKy3","save_btn":"Button_save_btn__-Xh-2","icon_button":"Button_icon_button__6KR4-"};